import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_HAS_QR_CODE_LINK_CUSTOM_LINK_DATA_STEP_VISITED =
  'UPDATE_HAS_QR_CODE_LINK_CUSTOM_LINK_DATA_STEP_VISITED' as const;

export const updateHasQrCodeLinkCustomLinkDataStepVisited = (visited: boolean) => ({
  data: { visited },
  type: UPDATE_HAS_QR_CODE_LINK_CUSTOM_LINK_DATA_STEP_VISITED,
});

export type UpdateHasQrCodeLinkCustomLinkDataStepVisitedResponseAction = DataAction<
  typeof UPDATE_HAS_QR_CODE_LINK_CUSTOM_LINK_DATA_STEP_VISITED,
  { visited: boolean }
>;
